// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2_FIc","left":"StickyBox_left__2QY2U","right":"StickyBox_right__1iwys"};